// TODO: to be removed with PAY_3067_ENHANCE_MILEAGE_EXPENSE_ITEMS
// LEGACY MILEAGE-LOCK group; see RequestMileageConfiguration.ts
import { type RequestMileageConfigurationApiModel } from '../api-models/RequestMileageConfigurationApiModel'

export interface MileageLockSettings {
  rate: number
  currencyId: number
  isLocked: boolean
}

export const mapRequestMileageConfigurationApiModel = (
  apiModel: RequestMileageConfigurationApiModel
): MileageLockSettings => ({
  rate: parseFloat(apiModel.value.rate),
  currencyId: apiModel.value.currency_id,
  isLocked: apiModel.value.is_locked,
})
